import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "Carouselstyles__Container",
  componentId: "sc-1s5fuzo-0"
})(["position:relative;width:100%;"]);
var Carousel = styled.div.withConfig({
  displayName: "Carouselstyles__Carousel",
  componentId: "sc-1s5fuzo-1"
})(["width:100%;"]);
export var Styled = {
  Container: Container,
  Carousel: Carousel
};